import { useState } from 'react';

export default function useFilters() {
  const [filters, setFilters] = useState<any>({});

  const handleFilterChange = (filterValue: any) => {
    setFilters({
      ...filters,
      ...filterValue,
    });
    const url = new URL(window.location.href);

    Object.keys(filterValue).forEach((key) => {
      if (filterValue[key] === '') {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, filterValue[key]);
      }
    });
    window.history.pushState({}, '', url.toString());
  };

  return {
    filters,
    setFilters,
    handleFilterChange,
  };
}
